/* eslint-disable max-len */
export default {
    text: 'This webpage uses cookies to provide services in accordance with our',
    privacy: 'Privacy policy.',
    button: 'OK'
};



// WEBPACK FOOTER //
// ./src/i18n/en/cookie.js